import { Adapter as r } from "../../../../adapter.js";
import { StampProgrammeDesignModel as s } from "./stampProgrammeDesign.model.js";
class c extends r {
  adapt(e) {
    return new s({
      colors: {
        accent: e.colors.accent,
        cardBackground: e.colors.card_background,
        cardStripImage: e.colors.card_strip_image,
        generalBackground: e.colors.general_background,
        progressBorder: e.colors.progress_border,
        text: e.colors.text
      },
      fontFamily: e.font_family,
      identifierCodeType: e.identifier_code_type,
      images: {
        background: e.images.background,
        logo: e.images.logo,
        stamp: e.images.stamp
      },
      progressBarType: e.progress_bar_type,
      texts: {
        currencyAlias: e.texts.currency_alias,
        customerAlias: e.texts.customer_alias,
        deactivationMessage: e.texts.deactivation_message,
        endCycleMessage: e.texts.end_cycle_message,
        endDateMessage: e.texts.end_date_message,
        legalText: e.texts.legal_text,
        rewardAlias: e.texts.reward_alias,
        rewardMessage: e.texts.reward_message,
        slogan: e.texts.slogan
      }
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  c as StampProgrammeDesignModelAdapter
};
//# sourceMappingURL=stampProgrammeDesign.adapter.js.map
